import { googleAuthHandler, post } from "../../api"; // API Types
import * as types from "./types.js"; // Redux actions payload types
import {
  set_cookie,
  remove_cookie,
  getNames,
  get_cookie,
  checkToken,
  loginSignUpGAEvent,
  clear_client_storage,
} from "./../../utils"; // Utility functions
import Routes from "./../../api/routes"; // API endpoint routes
import { Router } from "../../routes";
import { getUserInfo, setUserInfo } from "./user";
import { showSuccessPopup } from "./ui";
const {
  LOGIN,
  LOGOUT,
  SUBMIT_OTP,
  SOCIAL_LOGIN,
  SEND_VERIFY_EMAIL,
  VERIFY_EMAIL,
  VERIFY_NUMBER,
  VERIFY_OTP,
  USER_DELETE,
  SUBMIT_GUEST_OTP,
} = Routes;

/********************
@purpose : Used for login user
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const login = (data) => (dispatch) => {
  return post(LOGIN, true, data).then((res) => {
    if (res.statusCode == 200) {
      return res;
    }
    return Promise.reject(res);
  });
};
/********************
@purpose : Used for otp verification
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const submitOtp =
  (data, profile = true) =>
  (dispatch) => {
    return post(SUBMIT_GUEST_OTP, true, data).then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        dispatch(setToken(res.meta.access_token));

        // Store is_guest flag from meta object
        if (res?.meta?.is_guest !== undefined) {
          set_cookie("is_guest", res.meta.is_guest ? "true" : "false");
        }

        // Store complete OTP verification response for access in edit-details page
        if (typeof window !== "undefined") {
          sessionStorage.setItem(
            "otp_verification_response",
            JSON.stringify({
              data: res.data,
              meta: { ...res.meta, access_token: undefined },
              statusCode: res.statusCode,
              timestamp: new Date().toISOString(),
            })
          );
        }

        // Check if user is a guest (new user) using meta.is_guest
        const isGuest = res?.meta?.is_guest === true;

        // If user is a guest (new user), redirect directly to edit page
        // Skip login event - it will trigger after they complete their profile
        if (isGuest) {
          Router.push("/personal-details?desk=edit");
          return res.data;
        }

        // For existing users, trigger login event and continue with normal flow
        loginSignUpGAEvent();

        if (get_cookie("swp")) {
          Router.push("/wishlists");
          remove_cookie("swp");
        } else if (get_cookie("contract_url")) {
          Router.push(get_cookie("contract_url"));
          remove_cookie("contract_url");
        } else {
          if (Router?.query?.slug?.length != 6) {
            if (res?.data?.profile_completed == 0 && profile) {
              Router.push("/personal-details");
            }
          }
        }
        return res.data;
      }
      return Promise.reject(res);
    });
  };

/********************
@purpose : Used for clear browser storage and reload to redirect url after logout
@Parameter : { redirectTo }
******************/
const finishLogout = (redirectTo) => {
  const target = redirectTo || get_cookie("redirectUrl") || "/";
  clear_client_storage();
  window.location.replace(target);
};

/********************
@purpose : Used for logout user
@Parameter : { redirectTo, dispatch }
@Author : INIC
******************/
export const logout = (redirectTo) => () => {
  return post(LOGOUT, true, {})
    .catch((err) => err)
    .then((res) => {
      finishLogout(redirectTo);
      return res;
    });
};

/********************
@purpose : Used for delete user
@Parameter : { body, dispatch }
@Author : INIC
******************/
export const deleteUser = (body) => () => {
  return post(USER_DELETE, true, body).then((res) => {
    if (res?.success) {
      finishLogout();
      return Promise.resolve(res?.data);
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Used for set logout
@Parameter : { token }
@Author : INIC
******************/
export const setLogout = (payload) => {
  return {
    type: types.SET_LOGOUT,
    payload,
  };
};

/********************
@purpose : Used for store login responce and set token in cookie
@Parameter : { token }
@Author : INIC
******************/
export const setToken = (token) => {
  set_cookie("token", token);
  return {
    type: types.SET_TOKEN,
    token,
  };
};
/********************
@purpose : Used for store logout responce and remove token in cookie
@Parameter : { }
@Author : INIC
******************/
export const removeToken = () => {
  remove_cookie("token");
  return {
    type: types.REMOVE_TOKEN,
  };
};

export const getGoogleUserInfo = (data, locationId) => (dispatch) => {
  return googleAuthHandler(data)
    .then((res) => {
      dispatch(loginWithGoogleAuth(res, locationId));
    })
    .catch((err) => {
      dispatch(loginWithGoogleAuth(err, locationId));
    });
};

/********************
@purpose : Used for Social login
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const loginWithGoogle = (user, locationId) => (dispatch) => {
  if (user.error) {
    // user.error !== "popup_closed_by_user" && user.error !== "idpiframe_initialization_failed";
  } else {
    return post(SOCIAL_LOGIN, true, {
      login_type_id: user?.googleId,
      email: user?.profileObj?.email,
      social_photo: user?.profileObj?.imageUrl,
      first_name: user?.profileObj?.givenName
        ? user?.profileObj?.givenName
        : user?.profileObj?.name,
      last_name: user?.profileObj?.familyName,
      contact_number: "",
      date_of_birth: "",
      login_type: "google",
      location_id: locationId,
    }).then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        dispatch(setToken(res.meta.access_token));

        // Store is_guest flag from meta object for social login
        if (res?.meta?.is_guest !== undefined) {
          set_cookie("is_guest", res.meta.is_guest ? "true" : "false");
        }

        // Check if user is a guest (new user) using meta.is_guest
        const isGuest = res?.meta?.is_guest === true;

        // If user is a guest (new user), redirect directly to edit page
        // Skip login event - it will trigger after they complete their profile
        if (isGuest) {
          // Store social login data for pre-filling form
          if (typeof window !== "undefined") {
            sessionStorage.setItem(
              "social_login_data",
              JSON.stringify({
                email: user?.profileObj?.email,
                email_verified: user?.profileObj?.email_verified,
                first_name: user?.profileObj?.givenName,
                last_name: user?.profileObj?.familyName,
                photo: user?.profileObj?.imageUrl,
                login_type: "google",
              })
            );
          }

          Router.push("/personal-details?desk=edit");
          return Promise.resolve(res.data);
        }

        // For existing users, continue with normal flow
        if (get_cookie("swp")) {
          Router.push("/wishlists");
          remove_cookie("swp");
        } else if (get_cookie("contract_url")) {
          Router.push(get_cookie("contract_url"));
          remove_cookie("contract_url");
        } else {
          if (
            Router?.query?.slug?.length != 6 &&
            Router?.query?.slug?.length != 3 &&
            Router?.query?.slug?.length != 2 &&
            Router?.asPath != "/"
          ) {
            Router.push("/personal-details");
          }
        }

        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  }
};

export const loginWithGoogleAuth = (user, locationId) => (dispatch) => {
  if (user.error) {
    // user.error !== "popup_closed_by_user" && user.error !== "idpiframe_initialization_failed";
  } else {
    return post(SOCIAL_LOGIN, true, {
      login_type_id: user?.sub,
      email: user?.email,
      social_photo: user?.picture,
      first_name: user?.given_name ? user?.given_name : user?.name,
      last_name: user?.family_name,
      contact_number: "",
      date_of_birth: "",
      login_type: "google",
      location_id: locationId,
    }).then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        dispatch(setToken(res.meta.access_token));

        // Store is_guest flag from meta object for social login
        if (res?.meta?.is_guest !== undefined) {
          set_cookie("is_guest", res.meta.is_guest ? "true" : "false");
        }

        // Check if user is a guest (new user) using meta.is_guest
        const isGuest = res?.meta?.is_guest === true;

        // If user is a guest (new user), redirect directly to edit page
        // Skip login event - it will trigger after they complete their profile
        if (isGuest) {
          // Store social login data for pre-filling form
          if (typeof window !== "undefined") {
            sessionStorage.setItem(
              "social_login_data",
              JSON.stringify({
                email: user?.email,
                email_verified: user?.email_verified,
                first_name: user?.given_name,
                last_name: user?.family_name,
                photo: user?.picture,
                login_type: "google",
              })
            );
          }

          Router.push("/personal-details?desk=edit");
          return Promise.resolve(res.data);
        }

        // For existing users, continue with normal flow
        if (get_cookie("swp")) {
          Router.push("/wishlists");
          remove_cookie("swp");
        } else if (get_cookie("contract_url")) {
          Router.push(get_cookie("contract_url"));
          remove_cookie("contract_url");
        } else {
          if (
            Router?.query?.slug?.length != 6 &&
            Router?.query?.slug?.length != 3 &&
            Router?.query?.slug?.length != 2 &&
            Router?.asPath != "/"
          ) {
            Router.push("/personal-details");
          }
        }
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  }
};

/********************
@purpose : Used for Social login
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const loginWithFacebook = (user, locationId) => (dispatch) => {
  if (user.status == "unknown") {
    return;
  }
  return post(SOCIAL_LOGIN, true, {
    login_type_id: user?.id,
    email: user?.email,
    first_name: getNames(user?.name).firstName,
    last_name: getNames(user?.name).lastName,
    social_photo: user?.picture?.data?.url,
    contact_number: "",
    date_of_birth: "",
    login_type: "facebook",
    location_id: locationId,
  }).then((res) => {
    if (res.statusCode == 200) {
      dispatch(setUserInfo(res.data));
      dispatch(setToken(res.meta.access_token));

      // Store is_guest flag from meta object for social login
      if (res?.meta?.is_guest !== undefined) {
        set_cookie("is_guest", res.meta.is_guest ? "true" : "false");
      }

      // Check if user is a guest (new user) using meta.is_guest
      const isGuest = res?.meta?.is_guest === true;

      // If user is a guest (new user), redirect directly to edit page
      // Skip login event - it will trigger after they complete their profile
      if (isGuest) {
        // Store social login data for pre-filling form
        if (typeof window !== "undefined") {
          sessionStorage.setItem(
            "social_login_data",
            JSON.stringify({
              email: user?.email,
              email_verified: true, // Facebook emails are typically verified
              first_name: getNames(user?.name).firstName,
              last_name: getNames(user?.name).lastName,
              photo: user?.picture?.data?.url,
              login_type: "facebook",
            })
          );
        }

        Router.push("/personal-details?desk=edit");
        return Promise.resolve(res.data);
      }

      // For existing users, continue with normal flow
      if (get_cookie("swp")) {
        Router.push("/wishlists");
        remove_cookie("swp");
      } else if (get_cookie("contract_url")) {
        Router.push(get_cookie("contract_url"));
        remove_cookie("contract_url");
      } else {
        if (
          Router?.query?.slug?.length != 6 &&
          Router?.query?.slug?.length != 3 &&
          Router?.query?.slug?.length != 2 &&
          Router?.asPath != "/"
        ) {
          Router.push("/personal-details");
        }
      }
      return Promise.resolve(res.data);
    }

    return Promise.reject(res);
  });
};

/********************
@purpose : Used to verfiy user email
@Parameter : { email, dispatch }
@Author : INIC
******************/
export const sendVerifyEmail = (data) => (dispatch) => {
  return post(SEND_VERIFY_EMAIL, true, data).then((res) => {
    if (res.statusCode == 200) {
      if (data === "verify") {
        dispatch(showSuccessPopup(res.message));
      }
      return Promise.resolve(res);
    }
    //if otp already verified then go to personal-details
    return Promise.reject(res);
  });
};

/********************
@purpose : Used to verfiy user email
@Parameter : { email, dispatch }
@Author : INIC
******************/
export const verifyEmail = (data) => (dispatch) => {
  return post(VERIFY_EMAIL, true, data).then((res) => {
    if (res.statusCode == 200) {
      dispatch(showSuccessPopup(res.message));
      if (checkToken()) {
        dispatch(getUserInfo());
      } else {
        Router.push("/");
      }
      return Promise.resolve(res);
    }
    dispatch(showSuccessPopup(res.message, true));
    if (!checkToken()) {
      Router.push("/");
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Used to send user OTP
@Parameter : { email, dispatch }
@Author : INIC
******************/
export const sendVerifyOtp = (data) => (dispatch) => {
  return post(VERIFY_NUMBER, true, data).then((res) => {
    if (res.statusCode == 200) {
      return Promise.resolve(res);
    }
    dispatch(showSuccessPopup(res.message, true));
    return Promise.reject(res);
  });
};

/********************
@purpose : Used to verfiy
@Parameter : { email, dispatch }
@Author : INIC
******************/
export const verifyContactOtp = (data) => (dispatch) => {
  return post(VERIFY_OTP, true, data).then(async (res) => {
    if (res.statusCode == 200) {
      try {
        await dispatch(getUserInfo());
      } catch {
        dispatch(
          showSuccessPopup(
            "Your verification code was accepted, but your profile could not be refreshed. Please reload the page.",
            true
          )
        );
        return res;
      }
      dispatch(showSuccessPopup(res.message));
      return Promise.resolve(res);
    }
    dispatch(showSuccessPopup(res.message, true));
    return Promise.reject(res);
  });
};
